<!-- When an event goes live on /live (Video/Link.vue): join the Zoom meeting (Zoom's join page
     in a new tab: the app, or the browser), or close and stay on /live. Opens by itself as the
     first session after check-in starts, or on arriving while a session after check-in is live;
     never at check-in, never once joined (useLiveMeeting.js). Join Meeting has the focus. -->

<template>
  <AppModalDialog hash="join-meeting">
    <AppFormWrapper>
      <h2 class="title">Join the Meeting</h2>
      <p class="text">VIZBI <i>Online</i> is now live.</p>
      <p class="text">Click below to join the meeting via Zoom.</p>
    </AppFormWrapper>
    <template #footer>
      <!-- two buttons side by side: the dialog's own row (App/Modal/Dialog, .footer-buttons) -->
      <div class="footer-buttons">
        <ButtonBespoke @click="setHash('')">Close</ButtonBespoke>
        <ButtonBespoke outstanding autofocus @click="join">Join Meeting</ButtonBespoke>
      </div>
    </template>
  </AppModalDialog>
</template>

<script setup>
import {onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import AppModalDialog from "@/components/App/Modal/Dialog/index";
import AppFormWrapper from "@/components/App/Form/Wrapper";
import ButtonBespoke from "@/components/ButtonBespoke";
import {getIsDialogDue, markDialogOpened, markJoined} from "@/composables/useLiveMeeting";

const props = defineProps({meeting: {type: Object, required: true}});
const [route, router] = [useRoute(), useRouter()];

// on the same path: a hash alone resolves to the route's own path ("/Live"), and Main.vue keys
// /live by its path, so the page would remount and lose its state
function setHash(hash) {
  router.replace({path: route.path, query: route.query, hash});
}

function join() {
  markJoined(props.meeting.eventName);
  window.open(props.meeting.webUrl, "_blank", "noopener");
  setHash("");
}

onMounted(() => {
  const {eventName, isOpening, isCheckIn} = props.meeting;
  if (!getIsDialogDue(eventName, isOpening, isCheckIn)) return;
  markDialogOpened(props.meeting.eventName);
  setHash("#join-meeting");
});
</script>

<style scoped>
/* left-aligned, title and text (Seán, 2026-11-03): this dialog only for now; every dialog's
   default is on the roadmap (ROADMAP.md § Later, dialogs left-aligned), to be checked across
   them all first. The page's inherited centring (global.css) is what it overrides */
.title,
.text {
  text-align: left;
}
</style>
